var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from "react";
const prepareFileContent = (src, spriteId) => __awaiter(void 0, void 0, void 0, function* () {
    let result = "";
    try {
        const response = yield fetch(src, {
            headers: new Headers(),
            mode: "cors",
            cache: "no-cache",
        });
        const fileText = yield response.text();
        result = fileText.replace(/id="([^"]*)"/gm, `id="$1${spriteId}"`);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error(`An error happened while retrieving your src ${src}: `, error);
    }
    return result;
});
const useFileContent = ({ src, spriteId }) => {
    const [fileContent, setFileContent] = useState("");
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const newFileContent = yield prepareFileContent(src, spriteId);
            setFileContent(newFileContent);
        }))();
    }, [spriteId, src]);
    return fileContent;
};
export default useFileContent;
//# sourceMappingURL=useFileContent.js.map